import { ITag } from '../tagging/ITag';

export class SearchTermList {
  public id: string;
  public projectId: string;
  public name: string;
  public terms: string[];
  public tag: ITag;
  public tagWithRelated: ITag;
  public duplicateTag: ITag;

  constructor(id: string, projectId: string, name: string, terms: string[], tag?: ITag, tagWithRelated?: ITag, duplicateTag?: ITag) {
    this.id = id;
    this.projectId = projectId;
    this.name = name;
    this.terms = terms;
    this.tag = tag || null;
    this.tagWithRelated = tagWithRelated || null;
    this.duplicateTag = duplicateTag || null;
  }
}

namespace app.model.terms {
  export class SearchTermList {
    public id: string;
    public projectId: string;
    public name: string;
    public terms: string[];
    public tag: app.model.tagging.ITag;
    public tagWithRelated: app.model.tagging.ITag;
    public duplicateTag: app.model.tagging.ITag;

    constructor(id: string, projectId: string, name: string, terms: string[], tag?: app.model.tagging.ITag, tagWithRelated?: app.model.tagging.ITag, duplicateTag?: app.model.tagging.ITag) {
      this.id = id;
      this.projectId = projectId;
      this.name = name;
      this.terms = terms;
      this.tag = tag || null;
      this.tagWithRelated = tagWithRelated || null;
      this.duplicateTag = duplicateTag || null;
    }
  }
}
